export default __webpack_public_path__ + "static/media/Jador--Mansa.f03f28a8.mp3";